import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { InvoiceLinkType } from '@/types/invoiceVaultTypes';

export const getInvoiceLinksApi = (params: ApiParams): Promise<ApiResponseType<ListResponseType<InvoiceLinkType>>> => {
  return authApiService.GET('/invoice-vault/links/', params);
};
